// src/components/Seo.jsx
import { useEffect } from "react";

function setTag(selector, create) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
}

export default function Seo({
  title,
  description,
  canonical,
  ogImage,                // absolute URL recommended
  ogUrl,
  ogType = "website",
  twitterCard = "summary_large_image",
  jsonLd = null           // object or array of objects
}) {
  useEffect(() => {
    // Title
    if (title) document.title = title;

    // Description
    if (description) {
      const metaDesc = setTag('meta[name="description"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("name", "description");
        return m;
      });
      metaDesc.setAttribute("content", description);
    }

    // Canonical
    if (canonical) {
      // remove existing canonical(s)
      document.head.querySelectorAll('link[rel="canonical"]').forEach(n => n.remove());
      const link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      link.setAttribute("href", canonical);
      document.head.appendChild(link);
    }

    // Open Graph
    const setOg = (prop, content) => {
      if (!content) return;
      const el = setTag(`meta[property="${prop}"]`, () => {
        const m = document.createElement("meta");
        m.setAttribute("property", prop);
        return m;
      });
      el.setAttribute("content", content);
    };
    setOg("og:title", title);
    setOg("og:description", description);
    setOg("og:url", ogUrl || canonical);
    setOg("og:type", ogType);
    setOg("og:image", ogImage);
    if (ogImage) {
      setOg("og:image:width", "1200");
      setOg("og:image:height", "630");
    }

    // Twitter Card
    const twCard = setTag('meta[name="twitter:card"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("name", "twitter:card");
      return m;
    });
    twCard.setAttribute("content", twitterCard);

    if (title) {
      const twTitle = setTag('meta[name="twitter:title"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("name", "twitter:title");
        return m;
      });
      twTitle.setAttribute("content", title);
    }
    if (description) {
      const twDesc = setTag('meta[name="twitter:description"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("name", "twitter:description");
        return m;
      });
      twDesc.setAttribute("content", description);
    }
    if (ogImage) {
      const twImg = setTag('meta[name="twitter:image"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("name", "twitter:image");
        return m;
      });
      twImg.setAttribute("content", ogImage);
    }

    // JSON-LD (remove previous our-jsonld blocks, then add new)
    document.head.querySelectorAll('script[data-seo-jsonld="1"]').forEach(n => n.remove());
    if (jsonLd) {
      const items = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
      items.forEach(obj => {
        const s = document.createElement("script");
        s.type = "application/ld+json";
        s.setAttribute("data-seo-jsonld", "1");
        s.text = JSON.stringify(obj);
        document.head.appendChild(s);
      });
    }
  }, [title, description, canonical, ogImage, ogUrl, ogType, twitterCard, jsonLd]);

  return null;
}
